import {
  formatLocationCategory,
  formatLocationSpecialties,
  isBeyondNextDayAppointmentsEnabled,
  isOpenNow,
  isReliantVirtualVisit,
  isStandaloneTelemed,
  isTelemedLocation,
  isTraditionalLocation,
  shouldPromoteWalkingInWhenAllReservationsAreTaken,
  hasPhoneNumber,
  isBookable,
} from '../../../core/util/location';
import { isNativeApp } from '../../../core/util/device';

export const BREADCRUMBS = 'Breadcrumbs';
export const CLAIMING_LOCATION = 'Claiming location';
export const SELF_PAY_PRICES = 'Self pay prices';
export const SERVICES = 'Services';
export const FOOTER = 'Footer';
export const CDP_INFO_DESCRIPTION = 'Cdp info description';
export const INSURANCE_AND_PAYMENTS = 'Insurance and payments';
export const RECENTLY_BOOKED = 'Recently booked';
export const SCHEMA_ORG_MEDICAL_SPECIALTY = 'Schema org medical specialty property';
export const SCHEMA_ORG_PRICE_RANGE = 'Schema org price range';
export const SCHEMA_ORG_PAYMENTS_ACCEPTED = 'Schema org payments accepted';
export const CDP_TITLE_CATEGORY_OR_SPECIALTY = 'Cdp title, category or specialty';
export const SHARE_THE_CDP = 'Share the cdp';
export const BOOK_MODULE_NO_MORE_ONLINE_VISITS_ALTERNATIVES_COPY =
  ' Book module, no more online visits. Alternative options copy';
export const PASS_CHECKLIST_ADD_PREFERRED_PHARMACY = 'Pass checklist add preferred pharmacy';
export const PASS_CHECKLIST_VIEW_LIVE_WAITLIST = 'Pass checklist view live waitlist';
export const PASS_CHECKLIST_ADD_PAPERWORK = 'Pass checklist add paperwork';
export const PASS_CHECKLIST_ADD_PAYMENT_METHOD = 'Pass checklist add payment method';
export const PASS_CHECKLIST_VIEW_COST_BENEFITS = 'Pass checklist view cost benefits';
export const PASS_APPOINTMENT_FOOTNOTES = 'Pass appointment footnotes';
export const MORE_DATES_SLOT_SELECTOR = 'select more dates from the booking module';
export const MORE_DATES_URGENT_CARE = 'more dates for real availability fetching';
export const SHOW_DATES_ON_BOOK_BUTTON = 'show dates on the book button module';
export const SHOW_PHONE_NUMBER = 'show phone number';

export const getCustomization = (featureName: any, { location = {}, userAgent = null }: any) => {
  switch (featureName) {
    case BREADCRUMBS:
      if (isNativeApp(userAgent)) {
        return { shouldBeLinkable: false };
      }
      return { shouldBeLinkable: true };
    case CDP_INFO_DESCRIPTION:
      if (isNativeApp(userAgent)) {
        return { shouldBeLinkable: false };
      }
      return { shouldBeLinkable: true };
    case FOOTER:
      if (isNativeApp(userAgent)) {
        return { visible: false };
      }
      return { visible: true };
    case SERVICES:
      if (isNativeApp(userAgent)) {
        return { shouldBeLinkable: false };
      }
      return { shouldBeLinkable: true };
    case CLAIMING_LOCATION:
      if (isTraditionalLocation(location)) {
        return {
          visible: true,
          claimedText: 'This practice has been claimed',
          unclaimedText: 'Claim this practice',
        };
      }

      return {
        visible: true,
        claimedText: 'This clinic has been claimed',
        unclaimedText: 'Claim this clinic',
      };
    case INSURANCE_AND_PAYMENTS:
      return {
        insuranceSectionCollapsable: isTraditionalLocation(location),
        entity: isTraditionalLocation(location) ? 'Practice' : 'Clinic',
      };
    case SCHEMA_ORG_MEDICAL_SPECIALTY:
      if (isTraditionalLocation(location)) {
        return { value: formatLocationSpecialties(location) };
      }

      return { value: formatLocationCategory(location) };
    case CDP_TITLE_CATEGORY_OR_SPECIALTY:
      if (isTraditionalLocation(location)) {
        return { value: formatLocationSpecialties(location).split(',') };
      }

      return { value: formatLocationCategory(location) };
    case SHARE_THE_CDP:
      if (isTraditionalLocation(location)) {
        return { modalTitle: 'Share this Practice' };
      }

      return { modalTitle: 'Share this Clinic' };

    case SCHEMA_ORG_PRICE_RANGE:
    case SELF_PAY_PRICES:
    case SCHEMA_ORG_PAYMENTS_ACCEPTED:
    case RECENTLY_BOOKED:
    case PASS_CHECKLIST_ADD_PREFERRED_PHARMACY:
    case PASS_CHECKLIST_VIEW_LIVE_WAITLIST:
    case PASS_CHECKLIST_ADD_PAPERWORK:
    case PASS_CHECKLIST_VIEW_COST_BENEFITS:
    case PASS_APPOINTMENT_FOOTNOTES:
      return { visible: !isTraditionalLocation(location) };
    case BOOK_MODULE_NO_MORE_ONLINE_VISITS_ALTERNATIVES_COPY:
      return {
        visible:
          !isTraditionalLocation(location) &&
          !isTelemedLocation(location) &&
          shouldPromoteWalkingInWhenAllReservationsAreTaken(location) &&
          isOpenNow(location),
      };
    case PASS_CHECKLIST_ADD_PAYMENT_METHOD:
      return {
        visible:
          !isTraditionalLocation(location) &&
          !isReliantVirtualVisit(location) &&
          !isStandaloneTelemed(location),
      };
    case MORE_DATES_SLOT_SELECTOR:
    case SHOW_DATES_ON_BOOK_BUTTON:
      return { visible: isBeyondNextDayAppointmentsEnabled(location) };
    case SHOW_PHONE_NUMBER:
      return {
        visible: hasPhoneNumber(location) && !isTelemedLocation(location) && isBookable(location),
      };
    default:
      return { visible: true };
  }
};

export const shouldShowFeature = (featureName: any, location: any) =>
  getCustomization(featureName, { location }).visible;
